export const PlacementEndpoints = Object.freeze({
  start: (languageID: string) => `/v3/exam/placement/${languageID}/start`,
  finish: (languageID: string) => `/v3/exam/placement/${languageID}/finish`,
  placementCheckDone: (languageID: string) => `/v3/exam/placement/${languageID}`
})
